import {
  IconButton,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Competition } from 'shared/types/quotes';
import { CompetitionInputRow } from 'quoting/new-quote/table-input-rows/competition-input-row';
import { getCompetitionRowKey } from 'quoting/new-quote/helpers';

const tableStyles: SxProps = {
  borderRadius: '4px',
  boxShadow: 'rgb(0 0 0 / 20%) 0px 2px 1px -1px',
  backgroundColor: '#f0f0f0',
};

const CellStyles: SxProps = {
  fontSize: {
    xs: '12px',
    sm: '14px',
  },
};

interface Props {
  rows: Competition[];
  handleAddRow: (newRow: Competition) => void;
  handleRemoveRow: (row: Competition) => void;
}
export function CompetitionTable({ rows, handleRemoveRow, handleAddRow }: Props) {
  return (
    <TableContainer sx={tableStyles}>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography sx={CellStyles}>Specified Manufacturer</Typography>
            </TableCell>
            <TableCell>
              <Typography sx={CellStyles}>Model #</Typography>
            </TableCell>
            <TableCell>
              <Typography sx={CellStyles}>Current Market $</Typography>
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(row => (
            <TableRow key={getCompetitionRowKey(row)}>
              <TableCell>
                <Typography sx={CellStyles}>{row.modelName}</Typography>
              </TableCell>
              <TableCell>
                <Typography sx={CellStyles}>{row.modelNumber}</Typography>
              </TableCell>
              <TableCell>
                <Typography sx={CellStyles}>${row.currentMarketPrice}</Typography>
              </TableCell>
              <TableCell sx={{ padding: { xs: '5px', md: '6px 16px' } }}>
                <Tooltip title={<Typography variant='body2'>Remove</Typography>}>
                  <IconButton onClick={() => handleRemoveRow(row)}>
                    <RemoveCircleIcon color='error' />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
          <CompetitionInputRow handleAddRow={handleAddRow} />
        </TableBody>
      </Table>
    </TableContainer>
  );
}
